import { useRef, useEffect } from 'react'
import AttachMenu from './AttachMenu'

export default function ChatInput({ 
  inputText, 
  setInputText, 
  onSendMessage, 
  onKeyPress, 
  onVoiceMode,
  onFileUpload,
  onVideoMode,
  onRealtimeMode,
  showAttachMenu,
  setShowAttachMenu 
}) {
  const textareaRef = useRef(null)

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto'
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 200) + 'px'
    }
  }, [inputText])

  return (
    <div className="flex items-center gap-3">
      {/* + Button - Outside the input field */}
      <div className="relative">
        <button
          onClick={() => setShowAttachMenu(!showAttachMenu)}
          className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-200 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </button>
        
        {/* Attach Menu */}
        <AttachMenu
          showMenu={showAttachMenu}
          onFileUpload={onFileUpload}
          onVideoMode={onVideoMode}
          onClose={() => setShowAttachMenu(false)}
        />
      </div>

      {/* Text Input Field - Full rounded edges */}
      <div className="flex-1 relative flex items-center bg-gray-100 rounded-full px-4 py-2">
        <input
          ref={textareaRef}
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyPress={onKeyPress}
          placeholder="Ask anything"
          className="flex-1 border-none outline-none bg-transparent text-gray-900 placeholder-gray-500 text-sm"
        />

        {/* Microphone Button - Inside input field */}
        {!inputText.trim() && (
          <button
            onClick={onVoiceMode}
            className="ml-2 p-1 text-gray-500 hover:text-gray-700 transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
              <line x1="12" y1="19" x2="12" y2="23"/>
              <line x1="8" y1="23" x2="16" y2="23"/>
            </svg>
          </button>
        )}

        {/* Send Button - When typing */}
        {inputText.trim() && (
          <button
            onClick={onSendMessage}
            className="ml-2 p-1 text-gray-900 hover:text-gray-700 transition-colors"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="22" y1="2" x2="11" y2="13"/>
              <polygon points="22,2 15,22 11,13 2,9 22,2"/>
            </svg>
          </button>
        )}

        {/* Realtime Conversation Button - Inside input field on the right */}
        <button
          onClick={onRealtimeMode}
          className="ml-2 w-8 h-8 bg-black rounded-full flex items-center justify-center text-white hover:bg-gray-800 transition-colors"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <rect x="2" y="8" width="2.5" height="4" rx="1.25"/>
            <rect x="6" y="4" width="2.5" height="12" rx="1.25"/>
            <rect x="10" y="6" width="2.5" height="8" rx="1.25"/>
            <rect x="14" y="8" width="2.5" height="4" rx="1.25"/>
          </svg>
        </button>
      </div>
    </div>
  )
}
